"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentImage = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.ContentImage = (_a) => {
    var { className = '' } = _a, allProps = tslib_1.__rest(_a, ["className"]);
    return (React.createElement("img", Object.assign({ className: `clp-content-img ${className}` }, allProps)));
};
//# sourceMappingURL=ContentImage.js.map